import { Injectable } from '@angular/core';
import { appConfig } from '../../../app/app.config';
import { SharedService } from './../../shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class LocationItemService {

  constructor(
    public sharedService: SharedService
  ) { }

  /**
     * API call for getting Location Items
     * @param startDate Start Date
     * @param endDate End Date
     */
  getLocations(data: any, page: any) {
    let getLocationsUrl = appConfig.getLocationsItems;
    let location = data['location'];
    if (data['selectedView'] !== null && data['selectedView'] !== 'hourly_sales') {
      location = this.getDeselectedLocationIds(data['location']);
    }
    if (data['selectedView'] === 'hourly_sales') {
      const dateSortDir = page.sortField === 'transaction_date' ? page.sortOrder : 'DESC';
      const nameSortDir = page.sortField === 'name' ? page.sortOrder : 'ASC';
      getLocationsUrl = getLocationsUrl.concat('&dateSortDir=', dateSortDir);
      getLocationsUrl = getLocationsUrl.concat('&nameSortDir=', nameSortDir);
    }
    if ((data['selectedView'] === null) || (data['selectedView'] === 'hourly_sales')) {
      getLocationsUrl = getLocationsUrl.concat('&hasSearch=', page.hasSearch);
      getLocationsUrl = getLocationsUrl.concat('&limit=', page.limit);
      getLocationsUrl = getLocationsUrl.concat('&offset=', page.offset);
      getLocationsUrl = getLocationsUrl.concat('&searchText=', page.searchText);
      getLocationsUrl = getLocationsUrl.concat('&sortCol=', page.sortField);
      getLocationsUrl = getLocationsUrl.concat('&sortDir=', page.sortOrder);
    }
    if (data['selectedView'] !== null) {
      getLocationsUrl = getLocationsUrl.concat('&view=', data['selectedView']);
    }
    getLocationsUrl = getLocationsUrl.replace(':startDate', data['startDate'])
      .replace(':lastDate', data['lastDate'])
      .replace(':locationId', location);
    return this.sharedService.getData(getLocationsUrl);
  }

  getPresetData(presetName: string) {
    let getPresetDataUrl = appConfig.getPresetData;
    getPresetDataUrl = getPresetDataUrl.replace(':presetType', presetName);
    return this.sharedService.getDataWithHeaders(getPresetDataUrl);
  }

  addPresetData(presetData: any) {
    const addPresetDataUrl = appConfig.addPresetData;
    return this.sharedService.postData(addPresetDataUrl, presetData);
  }

  updatePresetData(presetData: any) {
    const updatePresetDataUrl = appConfig.updatePresetData;
    return this.sharedService.putData(updatePresetDataUrl, presetData);
  }

  updateSelectedPreset(presetData: any) {
    const updateSelectedPresetDataUrl = appConfig.updateSelectedPreset;
    return this.sharedService.putData(updateSelectedPresetDataUrl, presetData);
  }

  deletePresetData(presetId: any) {
    let deletePresetDataUrl = appConfig.deletePresetData;
    deletePresetDataUrl = deletePresetDataUrl.replace(':presetId', presetId);
    return this.sharedService.deleteData(deletePresetDataUrl);
  }

  getDeselectedLocationIds(location) {
    let finalLocationIds: any = [];
    finalLocationIds = JSON.parse(localStorage.getItem('levelsFilter'))['reg_loc_ids'];
    let deselectedLocIds = [];
    if (finalLocationIds !== undefined) {
      deselectedLocIds = finalLocationIds.filter((locId: any) => !location.includes(locId));
    }
    return deselectedLocIds;
  }
}
